import React from 'react';
import Icon from '../../../components/AppIcon';

const ProblemsSection = () => {
  const problems = [
    {
      id: 1,
      icon: 'AlertTriangle',
      iconColor: 'text-red-600',
      bgColor: 'bg-red-50',
      title: 'Operational Inefficiencies',
      description: 'Managing multiple facilities across different cities is consuming too much time and resources.',
      impact: 'Impact: 60% of leadership time spent on operations',
      impactColor: 'text-red-600'
    },
    {
      id: 2,
      icon: 'TrendingUp',
      iconColor: 'text-orange-600',
      bgColor: 'bg-orange-50',
      title: 'Rising Operational Costs',
      description: 'Facility management costs are spiraling out of control without proper oversight and optimization.',
      impact: 'Impact: 25-40% budget overrun annually',
      impactColor: 'text-orange-600'
    },
    {
      id: 3,
      icon: 'Users',
      iconColor: 'text-purple-600',
      bgColor: 'bg-purple-50',
      title: 'Resource Management Challenges',
      description: 'Difficulty in finding, training and retaining skilled manpower across multiple locations.',
      impact: 'Impact: 25-30% time lost in staffing issues',
      impactColor: 'text-purple-600'
    },
    {
      id: 4,
      icon: 'AlertCircle',
      iconColor: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      title: 'Compliance & Safety Risks',
      description: 'Ensuring consistent compliance and safety standards across all facilities is becoming increasingly complex.',
      impact: 'Impact: Regulatory risks and potential penalties',
      impactColor: 'text-yellow-600'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {problems?.map((problem) => (
            <div key={problem?.id} className="bg-card rounded-xl p-6 md:p-8 border border-border shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 rounded-lg ${problem?.bgColor} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={problem?.icon} size={28} className={problem?.iconColor} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-foreground mb-3">{problem?.title}</h3>
                  <p className="text-base text-muted-foreground mb-4">{problem?.description}</p>
                  <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${problem?.bgColor}`}>
                    <Icon name="AlertCircle" size={16} className={problem?.impactColor} />
                    <span className={`text-sm font-semibold ${problem?.impactColor}`}>{problem?.impact}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemsSection;